export class Definition {
	public term: string;
	public id: string;
	public value: string;
}
